import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredSearchFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g filter="url(#filter0_i_15069_275127)">
      <path
        d="M15.4896 13.022L12.233 9.76547C12.79 8.78528 13.082 7.68249 13.082 6.54088C13.082 2.93438 10.1478 0 6.54082 0C2.93382 0 0 2.93404 0 6.54054C0 10.147 2.93416 13.0814 6.54116 13.0814C7.68282 13.0814 8.78601 12.7895 9.76589 12.2324L13.0226 15.489C13.3519 15.8183 13.7902 16 14.2563 16C14.7223 16 15.1602 15.8187 15.49 15.489C16.17 14.8089 16.17 13.702 15.49 13.022H15.4896ZM9.62404 6.54054C9.62404 8.24058 8.24094 9.62363 6.54082 9.62363C4.8407 9.62363 3.45759 8.24058 3.45759 6.54054C3.45759 4.84049 4.8407 3.45745 6.54082 3.45745C8.24094 3.45745 9.62404 4.84049 9.62404 6.54054Z"
        fill="url(#paint0_linear_15069_275127)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_15069_275127"
        x={0}
        y={-2}
        width={16}
        height={18}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={-2} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_15069_275127"
        />
      </filter>
      <linearGradient
        id="paint0_linear_15069_275127"
        x1={12.9445}
        y1={16.5774}
        x2={5.24765}
        y2={3.26622}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A3FF" />
        <stop offset={1} stopColor="#83EAEC" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredSearchFilled)
const IconSvgColouredSearchFilled = createIcon(
  ForwardRef,
  'SvgColouredSearchFilled',
)
export default IconSvgColouredSearchFilled
